
import { useMutation } from 'react-query';
import { POST } from './http-service';
import { useClientStateDataUpdate } from 'hooks/clientStateData';
import isEqual from 'lodash/isEqual';

export function ValidateAnswer({  lngCode, clientStateData: currentClientStateData, useMock}) {
  const baseApi = `${lngCode}`;

  const clientStateDataUpdate = useClientStateDataUpdate();

  return {
    useAnswerMutation() {
      return useMutation(
        async ({ customerGUID, journeyGUID, questionAnswerDict, questionType, jsonData, propertyId, serviceId, serviceTypeId, unitId, appointmentTypeId, calendarIds, selectedSlot, selectedDate }) => {
          if (useMock) {
            return Promise.resolve(() => true);
          }
          const clientStateData = {};
          if (customerGUID) clientStateData.customerGUID = customerGUID;
          if (questionAnswerDict) clientStateData.questionAnswerDict =  questionAnswerDict;
          if (serviceId) clientStateData.serviceId =  serviceId;
          if (serviceTypeId) clientStateData.serviceTypeId =  serviceTypeId;
          if (unitId) clientStateData.unitId =  unitId;
          if (appointmentTypeId) clientStateData.appointmentTypeId =  appointmentTypeId;
          if (calendarIds) clientStateData.calendarIds =  calendarIds;
          if (selectedSlot) clientStateData.selectedSlot =  selectedSlot;
          if (selectedDate) clientStateData.selectedDate =  selectedDate;
          const params = {
            clientStateData: clientStateData || null,
            lngCode,
            propertyType: questionType,
            journeyGUID,
            jsonData,
            propertyId
          };

          const response = await POST(`${baseApi}/questions/validateanswer`, params);

          if (response.clientStateData && !isEqual(response.clientStateData, currentClientStateData)) {
            clientStateDataUpdate(response.clientStateData);
          }

          return response;
        }
      );
    },
  };
}
